import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import JournalPages from "../components/JournalPages";

const defaultQuotes = [
  "Breathe. Calm is a skill you practice.",
  "Safety is a signal you can teach your body.",
  "Notice, name, and normalize—then choose the next step.",
  "Energy needs direction; training gives it purpose.",
  "Slow is smooth. Smooth becomes fast.",
  "Detach from ‘what if’; return to ‘what now’.",
  "Gentle breath, grounded feet, kinder voice.",
  "You don’t have to fix it all—only the next thing.",
  "Signal, not sentence.",
  "Practice turns turbulence into steady current."
];

export default function JournalViewer() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  const shouldAutoPrint = useMemo(() => {
    return new URLSearchParams(window.location.search).get("autoprint") === "1";
  }, []);

  useEffect(() => {
    setData(null);
    setErr("");
    fetch(`/content/${slug}.json`, { cache: "no-store" })
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((json) => {
        setData(json);
        if (shouldAutoPrint) setTimeout(() => window.print(), 400);
      })
      .catch((e) => setErr(e.message));
  }, [slug, shouldAutoPrint]);

  if (err) {
    return (
      <div style={{ maxWidth: 760, margin: "48px auto", padding: 24 }}>
        <h2 style={{ marginTop: 0, color: "#b00020" }}>Couldn’t load this journal</h2>
        <p>Make sure the file exists at <code>public/content/{slug}.json</code>.</p>
        <p style={{ color: "#b00020" }}>Error: {err}</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div style={{ maxWidth: 720, margin: "48px auto", padding: 24 }}>
        <h2 style={{ marginTop: 0 }}>Loading…</h2>
      </div>
    );
  }

  return <JournalPages data={data} quotes={defaultQuotes} skin="page--whisper" />;
}
